import { render } from "./index.vue?vue&type=template&id=6ad87937&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6ad87937&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ad87937"

export default script